/**
 * This file contains all the global constants used in the application.
 */

import { platform } from '@/app/platform'

/**
 * The last hour to show in the calendar views. If the number is greater than 24, the calendar will show the next day.
 */
export const CALENDAR_LAST_HOUR = 24 + 8

const HTTP_HEADER_VERSION = 'PlanA-Version'
const HTTP_HEADER_VARIANT = 'PlanA-Variant'
const HTTP_HEADER_PLATFORM = 'PlanA-Platform'

const version = process.env.gitVersion ?? ''
const branch = process.env.gitBranch ?? ''

const showBranch = branch !== '' && !/^HEAD$|^main$/.test(branch)
const branchString = showBranch ? `[${branch}]` : ''
const versionString = `${version}${branchString}`

export const PLANA_HEADERS = {
  [HTTP_HEADER_VERSION]: versionString,
  [HTTP_HEADER_VARIANT]: 'PlanAPrivat',
  [HTTP_HEADER_PLATFORM]: platform(),
} as const
